import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import { StyledTextInput } from "../StyledComponents/StyledInputs";
import FormHelperText from "@mui/material/FormHelperText";
import { OrderDetailsInterface } from "../RFQOrders/interfaces";
import { StyledChip } from "../RFQOrders/NewRFQOrderDetails";

const RFQSellInfo = ({
  orderDetails,
}: {
  orderDetails: OrderDetailsInterface;
}) => {
  const [expandRFQInfo, setExpandRFQInfo] = useState(false);
  const newRFQData = useMemo(
    () => [
      { label: "Add RFQ Deal ID", value: orderDetails.rfq_deal_id },
      {
        label: "RFQ Order Number",
        value: orderDetails.rfq_order_number,
      },
      {
        label: "Accept RFQ Deal ID",
        value: "",
      },
      {
        label: "ICDM Order Number",
        value: "",
      },
      {
        label: "Product",
        value: orderDetails.bond_type,
      },
      { label: "User Type", value: "" },
      {
        label: "Quote Type",
        value: orderDetails.quotetype,
      },
      {
        label: "Minimum Value",
        value: orderDetails.offerminvalue,
        helperText: orderDetails?.quotetype,
      },
      {
        label: "Rating",
        value: orderDetails?.rating,
      },
      {
        label: "Rating Agency",
        value: orderDetails?.rating_agency,
      },
      {
        label: "GFD",
        value: orderDetails?.gfd,
      },
      {
        label: "OTOOTM",
        value: orderDetails?.otootm,
      },
      {
        label: "Deal Time Hours",
        value: orderDetails?.deal_time_hours,
      },
      {
        label: "Deal Time Minutes",
        value: orderDetails?.deal_time_minutes,
      },
      {
        label: "PROCLIENT",
        value: orderDetails?.pro_client,
      },
      {
        label: "Negotiable Flag",
        value: orderDetails.negotiable_flag,
      },
      {
        label: "Buyer Client Code",
        value: orderDetails.buyer_client_name,
      },
      {
        label: "Seller Client Code",
        value: orderDetails.sellerclientcode,
      },
      {
        label: "Direct Brokered",
        value: orderDetails.direct_brokered,
      },
      {
        label: "Disclosed Identity",
        value: orderDetails.disclosed_identity,
      },
      {
        label: "Seller Broker Code",
        value: orderDetails.sellerclientcode,
      },
      {
        label: "Buyer Broker Code",
        value: "",
      },
      {
        label: "Add RFQ Deal Time",
        value: "",
      },
      {
        label: "Accept RFQ Deal Time",
        value: "",
      },
    ],
    [orderDetails]
  );
  return (
    <Box sx={{ bgcolor: "#FFFFFF", p: 2, borderRadius: 5, mt: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">RFQ Information</Typography>
        <StyledChip
          label={expandRFQInfo ? "Collapse" : "Expand"}
          onClick={() => {
            setExpandRFQInfo(!expandRFQInfo);
          }}
          expandOrCollapse={expandRFQInfo}
        />
      </Box>
      <Box
        component="hr"
        sx={{ borderColor: "#7659EE", opacity: 0.5, mb: 4, mt: 2 }}
      />
      <Collapse in={expandRFQInfo}>
        <Grid container spacing={2}>
          {newRFQData.map((item, index) => (
            <Grid key={index} item xs={12} sm={4} md={3}>
              <FormControl fullWidth variant="standard">
                <InputLabel
                  shrink
                  htmlFor={`${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {item.label}
                </InputLabel>
                <StyledTextInput
                  id={`${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  disabled
                  value={item.value}
                />
                {item.helperText && (
                  <FormHelperText
                    sx={{
                      color: "#45E142",
                      fontSize: 12,
                      ml: 1,
                    }}
                  >
                    {item.helperText}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          ))}
        </Grid>
      </Collapse>
    </Box>
  );
};

export default RFQSellInfo;
